import type { UserSchema } from "@common/schemas/user.schema";

/** The name shown for a user: their name, else their email when the name is blank. */
export const getUserDisplayName = ({
    name,
    email,
}: Pick<UserSchema, "name" | "email">): string =>
    name.trim() !== "" ? name : (email ?? "");
